import React from 'react';
import Icon from '../../../components/AppIcon';


const SocialLoginButton = ({ provider, onClick, disabled = false }) => {
  const getProviderConfig = (provider) => {
    const configs = {
      google: {
        icon: 'Chrome',
        label: 'Continue with Google',
        bgColor: 'bg-white hover:bg-gray-50',
        textColor: 'text-gray-900',
        borderColor: 'border-gray-300'
      },
      apple: {
        icon: 'Apple',
        label: 'Continue with Apple',
        bgColor: 'bg-gray-900 hover:bg-gray-800',
        textColor: 'text-white',
        borderColor: 'border-gray-700'
      },
      facebook: {
        icon: 'Facebook',
        label: 'Continue with Facebook',
        bgColor: 'bg-blue-600 hover:bg-blue-700',
        textColor: 'text-white',
        borderColor: 'border-blue-600'
      }
    };
    return configs?.[provider] || configs?.google;
  };

  const config = getProviderConfig(provider);

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center justify-center space-x-3 px-4 py-3 rounded-lg border transition-all duration-300 premium-hover ${config?.bgColor} ${config?.textColor} ${config?.borderColor} disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      <Icon name={config?.icon} size={20} />
      <span className="font-medium">{config?.label}</span>
    </button>
  );
};

export default SocialLoginButton;